import type { GameDef } from '../registry';
import { formatTime } from '../../ui/format.ts';
import { mountSwipe, type SwipeConfig } from './view';

function swipeGame(cfg: SwipeConfig): GameDef {
  return { ...cfg.def, mount: (ctx) => mountSwipe(cfg, ctx) };
}

/** Course of Course — real Whitman courses vs made-up ones */
export const courseOrCourse = swipeGame({
  def: {
    id: 'courses',
    title: 'Course of Course',
    icon: '📚',
    blurb: 'Real Whitman course, or one we made up? Swipe right if it is in the catalog, left if it is not. 24 cards against the clock.',
    howTo: [
      'A course title and department appear on a card. Swipe right (or tap ✓) if it is a real course in the Whitman catalog, left (or tap ✕) if it is made up.',
      'Made-up courses get sneakier as the round goes on: silly mash-ups first, then real titles in the wrong department, then a single swapped word.',
      'Each card gives you 6 seconds. A wrong swipe, or running out of time, adds 3 seconds.',
      'Your time for all 24 cards is your score. Fastest wins the leaderboard.',
    ],
    scoreLabel: 'time',
    lowerIsBetter: true,
    formatScore: formatTime,
  },
  deckUrl: `${import.meta.env.BASE_URL}decks/courses.json`,
  realLabel: 'In the catalog',
  fakeLabel: 'Made up',
  intro: 'Real Whitman courses are mixed with ones we invented. Some inventions are silly. Some are one word off.',
});

/** Whitman: Fact or Fiction — campus facts vs near misses */
export const whitmanFacts = swipeGame({
  def: {
    id: 'whitman',
    title: 'Whitman: Fact or Fiction',
    icon: '🎓',
    blurb: 'Founded in 1859? Mascot the Blues? Swipe right for true, left for false — the fakes are near misses.',
    howTo: [
      'A statement about Whitman College appears. Swipe right (or tap ✓) if it is true, left (or tap ✕) if it is not.',
      'The false ones are deliberate near misses: the wrong year, the wrong building, the wrong team name.',
      'Each card gives you 6 seconds. A wrong swipe, or running out of time, adds 3 seconds.',
      'Your time for all 24 cards is your score.',
    ],
    scoreLabel: 'time',
    lowerIsBetter: true,
    formatScore: formatTime,
  },
  deckUrl: `${import.meta.env.BASE_URL}decks/whitman.json`,
  realLabel: 'True',
  fakeLabel: 'False',
  intro: 'Everything here is either a real fact about Whitman or a near miss. Sources are on the card after you answer.',
});
